module.exports = {
	"ha": "vcha",
	"id": 5.6,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.6</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by PWID Status, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -125,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 99.26229508196721,
						"dataLabels": {
							"enabled": true,
							"format": "1211"
						}
					},
					{
						"y": 94.83606557377048,
						"dataLabels": {
							"enabled": true,
							"format": "1157"
						}
					},
					{
						"y": 89.18032786885246,
						"dataLabels": {
							"enabled": true,
							"format": "1088"
						}
					},
					{
						"y": 80.49180327868852,
						"dataLabels": {
							"enabled": true,
							"format": "982"
						}
					},
					{
						"y": 63.114754098360656,
						"dataLabels": {
							"enabled": true,
							"format": "770"
						}
					},
					{
						"y": null
					},
					{
						"y": 98.85781803859788,
						"dataLabels": {
							"enabled": true,
							"format": "2510"
						}
					},
					{
						"y": 89.40527766837337,
						"dataLabels": {
							"enabled": true,
							"format": "2270"
						}
					},
					{
						"y": 85.78180385978732,
						"dataLabels": {
							"enabled": true,
							"format": "2178"
						}
					},
					{
						"y": 81.33123276880661,
						"dataLabels": {
							"enabled": true,
							"format": "2065"
						}
					},
					{
						"y": 73.49350137849548,
						"dataLabels": {
							"enabled": true,
							"format": "1866"
						}
					},
					{
						"y": null
					},
					{
						"y": 90.78830823737822,
						"dataLabels": {
							"enabled": true,
							"format": "1025"
						}
					},
					{
						"y": 65.45615589016829,
						"dataLabels": {
							"enabled": true,
							"format": "739"
						}
					},
					{
						"y": 62.8875110717449,
						"dataLabels": {
							"enabled": true,
							"format": "710"
						}
					},
					{
						"y": 58.54738706820195,
						"dataLabels": {
							"enabled": true,
							"format": "661"
						}
					},
					{
						"y": 52.79007971656333,
						"dataLabels": {
							"enabled": true,
							"format": "596"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -0.7377049180327888,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.459124690338568,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.963699222126184,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.742647058823529,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.588594704684315,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.1421819614021222,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.561752988047811,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.052863436123344,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.188246097337002,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.636803874092015,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -9.211691762621788,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.902439024390247,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.9242219215155583,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.901408450704228,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.833585476550677,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "PWID<br>n=1220"
			},
			{
				"x": 9,
				"text": "Non-PWID<br>n=2539"
			},
			{
				"x": 15,
				"text": "Unknown<br>n=1129"
			}
		],
		"dataTable": {
			"IDU": [
				1220,
				1211,
				1157,
				1088,
				982,
				770
			],
			"Non-IDU": [
				2539,
				2510,
				2270,
				2178,
				2065,
				1866
			],
			"Unknown": [
				1129,
				1025,
				739,
				710,
				661,
				596
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_6.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_6.json
// module id = 306
// module chunks = 0